import React from 'react';

const formatDisplay = (raw) => {
  if (raw == null || raw === '') return '';
  const digits = String(raw).replace(/[^\d.]/g, '');
  if (!digits) return '';
  const [intPart, decPart] = digits.split('.');
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart != null ? `${withCommas}.${decPart}` : withCommas;
};

class CurrencyField extends React.Component {
  handleChange = (e) => {
    const { onChange } = this.props;
    if (!onChange) return;
    const cleaned = e.target.value.replace(/[^\d.]/g, '');
    onChange(cleaned);
  };

  render() {
    const {
      value,
      placeholder,
      required,
      label,
      disabled,
      prefix,
      suffix,
      ariaLabel,
      fieldId,
      error,
      hint,
    } = this.props;
    const hasError = !!error;
    const prefixSymbol = prefix === undefined ? '$' : prefix;

    return (
      <div className="w-full" data-field-id={fieldId || undefined}>
        {label ? (
          <label className="block text-sm font-medium text-[#1F2937] mb-2">
            {label}
            {required ? <span className="text-[#DC2626] ml-1">*</span> : null}
          </label>
        ) : null}
        <div
          className="flex items-center w-full rounded-lg border bg-white focus-within:ring-2"
          style={{
            borderColor: hasError ? '#DC2626' : '#D1D5DB',
            boxShadow: hasError ? '0 0 0 1px #DC2626' : undefined,
          }}
        >
          {prefixSymbol ? (
            <span className="pl-3 pr-1 text-[#6B7280] font-medium">{prefixSymbol}</span>
          ) : null}
          <input
            type="text"
            inputMode="decimal"
            aria-label={ariaLabel || label || 'Amount'}
            aria-invalid={hasError || undefined}
            required={required}
            disabled={disabled}
            placeholder={placeholder || '0'}
            value={formatDisplay(value)}
            onChange={this.handleChange}
            className={`w-full bg-transparent outline-none py-2.5 pr-2 text-sm sm:text-base text-[#1F2937] disabled:opacity-60 ${
              prefixSymbol ? '' : 'pl-3'
            }`}
          />
          {suffix ? (
            <span className="px-3 text-xs text-[#6B7280] whitespace-nowrap">
              {suffix}
            </span>
          ) : null}
        </div>
        {hasError ? (
          <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : hint ? (
          <p className="mt-1 text-xs text-[#6B7280]">{hint}</p>
        ) : null}
      </div>
    );
  }
}

export default CurrencyField;
